module.exports = __webpack_public_path__ + "static/media/transfer-PENDING.8ce7e829.svg";